import React from 'react';
import { IonPage, IonContent, IonText, IonButton, IonIcon, IonGrid, IonRow, IonCol } from '@ionic/react';
import { lockClosedOutline, arrowBackOutline } from 'ionicons/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Unauthorized: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate('/app');
  };

  return (
    <IonPage>
      <IonContent className="ion-padding ion-text-center">
        <IonGrid className="ion-justify-content-center ion-align-items-center" style={{ height: '100%' }}>
          <IonRow className="ion-justify-content-center">
            <IonCol size="12" sizeMd="8" sizeLg="6">
              <IonIcon 
                icon={lockClosedOutline} 
                size="large" 
                color="danger"
                style={{ fontSize: '4rem', marginBottom: '1rem' }}
              />
              
              <IonText color="danger">
                <h1>{t('pages.unauthenticated.Unauthorized.accessDenied')}</h1>
                <p>{t('pages.unauthenticated.Unauthorized.youDonTHavePermissionTo')}</p>
                <p>{t('pages.unauthenticated.Unauthorized.pleaseContactYourAdministratorIfYou')}</p>
              </IonText>

              <IonRow className="ion-justify-content-center ion-margin-top">
                <IonCol size="auto">
                  <IonButton 
                    fill="outline" 
                    color="medium"
                    onClick={handleGoBack}
                  >
                    <IonIcon icon={arrowBackOutline} slot="start" />{t('pages.unauthenticated.Unauthorized.goBack')}
                  </IonButton>
                </IonCol>
                
                <IonCol size="auto">
                  <IonButton 
                    color="primary"
                    onClick={handleGoHome}
                  >{t('pages.unauthenticated.Unauthorized.goToDashboard')}
                  </IonButton>
                </IonCol>
              </IonRow>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default Unauthorized;
